export default "__VITE_ASSET__XOCyqqjB__"